// Mirrors classifyArgsSchema in packages/middleware/src/cpg/classify.runner.ts — keep the
// shape in sync: { documentIds?: number[] }, no ids = sweep every document currently in
// pending_classification.
export function extractDocumentIds(value: unknown): unknown {
  if (typeof value === 'object' && value !== null && 'documentIds' in value) {
    return (value as Record<string, unknown>).documentIds
  }
  return undefined
}

/** '12, 34 56' → [12, 34, 56]; invalid tokens map to NaN so validation rejects them. */
export function parseIdList(text: string): number[] {
  return text
    .split(/[\s,]+/)
    .filter((token) => token !== '')
    .map((token) => (/^\d+$/.test(token) ? Number(token) : NaN))
}

export function formatIdList(ids: unknown): string {
  return Array.isArray(ids) ? ids.join(', ') : ''
}

export function validateClassifyArgs(value: unknown): string | null {
  if (value === undefined || value === null) return null
  if (typeof value !== 'object' || Array.isArray(value)) {
    return 'Args must be an object'
  }
  const ids = extractDocumentIds(value)
  if (ids === undefined) return null
  if (!Array.isArray(ids) || ids.some((id) => !Number.isInteger(id) || (id as number) <= 0)) {
    return 'Document ids must be positive integers'
  }
  if (ids.length === 0) {
    return 'Provide at least one document id, or leave empty to sweep all pending'
  }
  return null
}
